// App.tsx
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import MenuPage from './pages/MenuPage';
import BuilderPage from './pages/BuilderPage';
import StyleWrapper from './components/shared/StyleWrapper';

// Environment variables
const bypassProtection = !!process.env.REACT_APP_BYPASS;
const defaultRoute = process.env.REACT_APP_DEFAULT_ROUTE || '/';

// Hoist router outside the component so it is only created once.
// React Router v7 warns when createBrowserRouter is called on every render.
const builderElement = bypassProtection ? <BuilderPage /> : <StyleWrapper><BuilderPage /></StyleWrapper>;

const router = createBrowserRouter([
  {
    path: '/',
    element: defaultRoute !== '/' ? <Navigate to={defaultRoute} replace /> : <HomePage />
  },
  {
    path: '/menu',
    element: <MenuPage />
  },
  {
    path: '/portal/maps',
    element: builderElement
  },
  {
    path: '/portal/maps/:mapId',
    element: builderElement
  },
  // Catch-all route that redirects to home
  {
    path: '*',
    element: <Navigate to="/" replace />
  }
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
